import store from "../store";
import * as actions from "../actions";
import React from "preact";
import constants from "../constants";
import { useEffect, useState } from "preact/hooks";
import "../../scss/favorite-button.scss";
import favoriteAssetService from "../service/favoriteAssetService";
import Interactable from "../canvas/interactable";
const { dispatch } = store;
const { goToView, goToSubview, setSelectionType } = actions;

interface FavoriteButtonProps {
  isFavorite?: boolean;
  assetId: string;
  type: string;
  callback?: () => void;
}

export default function FavoriteButton({ isFavorite = false, assetId, type, callback }: FavoriteButtonProps) {
  const [isFavoriteActive, setIsFavoriteActive] = useState(isFavorite);

  useEffect(() => {
    setIsFavoriteActive(isFavorite);
  }, [isFavorite]);

  function toggleFavorite(e: any) {
    e.stopPropagation();
    e.preventDefault();

    const newState = !isFavoriteActive;

    setIsFavoriteActive(newState);

    if (isFavoriteActive) {
      favoriteAssetService.removeFavoriteAsset(assetId, store.getState().memberId).then((response) => {
        console.log(response);
        callback?.();
        Interactable.reloadAndRefreshFavorites();
      });
    } else {
      favoriteAssetService.createFavoriteAsset(store.getState().memberId, assetId, type).then((response) => {
        console.log(response);
        callback?.();
        Interactable.reloadAndRefreshFavorites();
      });
    }
  }

  return <div className={`favorite-button hint--bottom ${isFavoriteActive ? 'active' : ''}`} data-hint={isFavoriteActive ? 'Unfavorite' : 'Favorite'} onClick={toggleFavorite}>
    {isFavoriteActive
      ? <svg>
        <use xlinkHref={constants.appPrefix + "/svg/icons.svg#heart-filled-icon"} />
      </svg>
      :
      <>
      <svg className="heart-outlined-icon">
        <use xlinkHref={constants.appPrefix + "/svg/icons.svg#heart-outlined-icon"} />
      </svg>
      <svg className="heart-filled-icon" style={{ display: 'none' }}>
        <use xlinkHref={constants.appPrefix + "/svg/icons.svg#heart-filled-icon"} />
      </svg>
      </>
    }
  </div>
}
